import { type Dispatch } from 'redux';
import { type Ancillary, type PrescriptionsWithAncillaries } from '~shared/features/my-meds/types';
import { get } from '~shared/helpers/apiHelper';
import { type APIError } from '~shared/types';

const DEFAULT_OPTIONS = {
  version: 'v3',
};
export const FETCH_ANCILLARIES_LOADING = 'FETCH_ANCILLARIES_LOADING';
export type FetchingAncillaries = {
  type: typeof FETCH_ANCILLARIES_LOADING;
};
export function fetchingAncillaries(): FetchingAncillaries {
  return {
    type: FETCH_ANCILLARIES_LOADING,
  };
}

export const FETCH_ANCILLARIES_SUCCEEDED = 'FETCH_ANCILLARIES_SUCCEEDED';
export type FetchingAncillariesSucceeded = {
  type: typeof FETCH_ANCILLARIES_SUCCEEDED;
  payload: PrescriptionsWithAncillaries;
};
export function fetchingAncillariesSucceeded(ancillaries: Record<string, Ancillary[]>): FetchingAncillariesSucceeded {
  return {
    type: FETCH_ANCILLARIES_SUCCEEDED,
    payload: ancillaries,
  };
}

export const FETCH_ANCILLARIES_FAILED = 'FETCH_ANCILLARIES_FAILED';
export type FetchingAncillariesFailed = {
  type: typeof FETCH_ANCILLARIES_FAILED;
  payload: APIError;
};
export function fetchingAncillariesFailed(ancillariesError: APIError): FetchingAncillariesFailed {
  return {
    type: FETCH_ANCILLARIES_FAILED,
    payload: ancillariesError,
  };
}

export type AncillariesAction = FetchingAncillaries | FetchingAncillariesSucceeded | FetchingAncillariesFailed;

/**
 * @deprecated Redux networking action.
 * @see https://www.notion.so/alto/Guidebook-Migrating-Redux-Networking-Actions-To-React-Query-8567e05fc96c46fcb8020595f24b0edc
 */
export function fetchAncillaries(prescriptionID: number): (dispatch: Dispatch<AncillariesAction>) => Promise<boolean> {
  return (dispatch) => {
    dispatch(fetchingAncillaries());
    return get(`/prescriptions/${prescriptionID}/ancillaries`, {}, DEFAULT_OPTIONS).then((json) => {
      if (json?.error) {
        dispatch(fetchingAncillariesFailed(json?.error));
        return false;
      }

      const ancillaryItem: Ancillary | undefined = json.data?.[0];
      if (ancillaryItem) {
        dispatch(
          fetchingAncillariesSucceeded({
            [ancillaryItem.prescription_id]: json.data as Ancillary[],
          }),
        );
      }
      return json;
    });
  };
}
